import ApiRoutes from "api/apiRoutes";
import { exeRequest } from "http/requestConfig";

export default class DashboardService {

    static readStats(sCallBack, eCallBack) {
        exeRequest(ApiRoutes.readStatsResource, {}, sCallBack, eCallBack)
    }

}